import { render, staticRenderFns } from "./CoreTableResult.vue?vue&type=template&id=0f2349d4&"
import script from "./CoreTableResult.vue?vue&type=script&lang=js&"
export * from "./CoreTableResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2349d4')) {
      api.createRecord('0f2349d4', component.options)
    } else {
      api.reload('0f2349d4', component.options)
    }
    module.hot.accept("./CoreTableResult.vue?vue&type=template&id=0f2349d4&", function () {
      api.rerender('0f2349d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Cores/CoreTableResult.vue"
export default component.exports